/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface DocumentAdmin
 */
export interface DocumentAdmin {
  /**
   *
   * @type {number}
   * @memberof DocumentAdmin
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof DocumentAdmin
   */
  slug?: string | null
  /**
   *
   * @type {string}
   * @memberof DocumentAdmin
   */
  name?: string | null
}

/**
 * Check if a given object implements the DocumentAdmin interface.
 */
export function instanceOfDocumentAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value

  return isInstance
}

export function DocumentAdminFromJSON(json: any): DocumentAdmin {
  return DocumentAdminFromJSONTyped(json, false)
}

export function DocumentAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DocumentAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    slug: !exists(json, 'slug') ? undefined : json['slug'],
    name: !exists(json, 'name') ? undefined : json['name'],
  }
}

export function DocumentAdminToJSON(value?: DocumentAdmin | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    slug: value.slug,
    name: value.name,
  }
}
